import { FC } from 'react';
import { useTranslation } from 'react-i18next';

const DonationDashboard: FC = () => {
  const { t } = useTranslation('dashboard.DonationDashboard');

  return (
    <div>
      <h2>{t('donationDashboardTitle')}</h2>
      <p>{t('donationDashboardDescription')}</p>
      {/* Add your dashboard content here */}
      {/* This could include charts, statistics, tables, etc. */}
    </div>
  );
};

export default DonationDashboard;
